(() => {
  const normalizeId = (value, index) => {
    const slug = value
      .trim()
      .toLowerCase()
      .normalize('NFKD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9\s-]/g, '')
      .replace(/\s+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '');

    return slug || `article-section-${index + 1}`;
  };

  const initializeArticleLayout = (layout) => {
    const content = layout.querySelector('[data-article-content]');
    if (!content) return;

    const levelTwoHeadings = Array.from(content.querySelectorAll('h2'));
    const candidateHeadings = levelTwoHeadings.length > 0
      ? levelTwoHeadings
      : Array.from(content.querySelectorAll('h3'));
    const headings = candidateHeadings.filter(
      (heading) => heading.textContent.trim().length > 0
    );

    if (headings.length === 0) return;

    const usedIds = new Set();
    headings.forEach((heading, index) => {
      let id = heading.id || normalizeId(heading.textContent, index);
      let uniqueId = id;
      let suffix = 2;

      while (usedIds.has(uniqueId) || (document.getElementById(uniqueId) && document.getElementById(uniqueId) !== heading)) {
        uniqueId = `${id}-${suffix}`;
        suffix += 1;
      }

      heading.id = uniqueId;
      usedIds.add(uniqueId);
    });

    const toc = layout.querySelector('[data-article-toc]');
    const tocList = layout.querySelector('[data-toc-list]');
    if (toc && tocList) {
      headings.forEach((heading) => {
        const item = document.createElement('li');
        const link = document.createElement('a');
        link.href = `#${heading.id}`;
        link.textContent = heading.textContent.trim();
        item.appendChild(link);
        tocList.appendChild(item);
      });
      toc.hidden = false;
      const articleGrid = layout.querySelector('.article-layout');
      if (articleGrid) articleGrid.classList.add('article-layout--with-toc');
    }

    const checklist = layout.querySelector('[data-article-checklist]');
    const checklistList = layout.querySelector('[data-checklist-list]');
    if (checklist && checklistList) {
      headings.slice(0, 4).forEach((heading) => {
        const item = document.createElement('li');
        item.textContent = heading.textContent.trim();
        checklistList.appendChild(item);
      });
      checklist.hidden = false;
    }
  };

  document.querySelectorAll('[data-article-layout]').forEach(initializeArticleLayout);
})();
